import React, { useContext, useState } from "react";
import { View, TextInput, Dimensions } from "react-native";
import { useColorScheme } from "react-native-appearance";
import { colors } from "../context/Colors";
import AppContext from "../context";
import GameFooter from "./GameFooter";
import GameDescription from "./GameDescription";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";

export default function Blanks({ g, current }) {
  const theme = useColorScheme() === "dark" ? "dark" : "light";
  const { tour, setTour } = useContext(AppContext);
  const inputRefs = React.useRef([]);
  const [textInputY, setTextInputY] = useState(0);

  const [values, setValues] = React.useState(
    g.propositions.map((p, i) => p.answer)
  );

  if (inputRefs.current.length !== g.propositions.length) {
    // add or remove refs
    inputRefs.current = Array(g.propositions.length)
      .fill()
      .map((_, i) => inputRefs.current[i] || React.createRef());
  }
  if (values.length !== g.propositions.length) {
    console.log("init values");

    // setValues(Array(g.propositions.length)
    //   .fill().map((_, i) => g.propositions[i].answer));
  }
  const handleBackSpace = (l, k) => {
    if (l === "Backspace") {
      g.propositions[k].answer = "";
      setTour({ ...tour });
      findNextInput("", k);
      const val = values.map((item, j) => {
        if (j === k) {
          return "";
        } else {
          return item;
        }
      });
      setValues(val);
    }
  };
  const setLetter = (l, k) => {
    if (l === "Backspace") {
      g.propositions[k].answer = "";
      setTour({ ...tour });
      findNextInput("", k);
      const val = values.map((item, j) => {
        if (j === k) {
          return "";
        } else {
          return item;
        }
      });
      setValues(val);
    } else if (l.trim().length) {
      const answer = l.toUpperCase().charAt(0);
      const val = values.map((item, j) => {
        if (j === k) {
          return answer;
        } else {
          return item;
        }
      });
      setValues(val);
      g.answer = "";
      g.propositions[k].answer = l.toUpperCase().charAt(0);
      g.propositions.some((p) => {
        g.answer = g.answer + (p.flag ? p.text : p.answer);
      });
      g.state = g.answer.length === g.propositions.length ? "can-answer" : "";
      setTour({ ...tour });
      findNextInput(l, k);
    }
  };

  const letterColor = (a) => {
    if (a.text === " ") return colors[theme].bg;
    if (g.state === "failed") return "#DD4D4D";
    if (g.state === "correct") return "#26C97A";
    return colors[theme].text;
  };

  const findNextInput = (l, k) => {
    if (l && l !== "") {
      if (g.propositions[k + 1]) k++;
      else {
        inputRefs.current[k].current.blur();
        return;
      }
    } else if (l === "") {
      if (k !== 0 && g.propositions[k - 1]) k--;
      else {
        inputRefs.current[k].current.blur();
        return;
      }
    }
    if (!g.propositions[k].flag) {
      inputRefs.current[k].current.focus();
    } else {
      if (k !== 0) findNextInput(l, k);
    }
  };

  const render = () => (
    <>
      <GameDescription g={g} current={current} />
      <View
        style={{ marginTop: 20, flexDirection: "row", flexWrap: "wrap" }}
        onLayout={(e) => {
          setTextInputY(e.nativeEvent.layout.y);
        }}
      >
        {g.propositions.map((p, k) => (
          <TextInput
            key={k}
            style={{
              borderBottomColor: letterColor(p),
              borderBottomWidth: 2,
              paddingVertical: 4,
              marginRight: 6,
              width: 25,
              textAlign: "center",
              fontWeight: "bold",
              fontSize: 18,
              color: letterColor(p),
              marginBottom: 20,
              opacity:
                p.flag && g.state !== "failed" && g.state !== "correct"
                  ? 0.4
                  : 1,
            }}
            value={p.flag ? p.text : values[k]}
            onChangeText={(e) => setLetter(e, k)}
            editable={!p.flag && g.state !== "failed" && g.state !== "correct"}
            ref={inputRefs.current[k]}
            maxLength={1}
            autoCorrect={false}
            autoCapitalize={"characters"}
            selectTextOnFocus={true}
            onKeyPress={(e) => handleBackSpace(e.nativeEvent.key, k)}
            // onChange={(e) => {
            //   setLetter(e.nativeEvent.text, k);
            // }}
            // onFocus={(e) => {
            //   inputRefs.current[k].setSelection({start:0,end:1})
            // }}
            // selection={{ start: 0, end: 1 }}
            // autoFocus={false}
          />
        ))}
      </View>
      <GameFooter g={g} />
      <View style={{ height: 60 }} />
    </>
  );

  if (textInputY + 200 > Dimensions.get("screen").height / 2)
    return (
      <KeyboardAwareScrollView extraHeight={250}>
        {render()}
      </KeyboardAwareScrollView>
    );
  else return render();
}
